import {useRepositories} from '@web-libs/core/repositories/application/repository-concerns';
import {_useCmsPage} from '@web-libs/features/cms/application/_use-cms-page';

export const useCmsPage = () => {
    const {getRepo} = useRepositories();
    const cmsRepository = getRepo('CmsRepository');

    return _useCmsPage(cmsRepository.getCmsPageForInstitutionByType);
};
